import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useImageUploaderDialog = () => {
  const store = useCreativeTemplatesBuilderStore();

  const handleOpenImageUploaderDialog = () => store.setOpenImageUploaderDialog(true);
  const handleCloseImageUploaderDialog = () => store.setOpenImageUploaderDialog(false);

  return {
    openImageUploaderDialog: store.openImageUploaderDialog,
    handleCloseImageUploaderDialog,
    handleOpenImageUploaderDialog
  };
};
